import { GlIcon } from '@gitlab/ui';
import { STATUS_CLOSED, STATUS_MERGED, STATUS_EMPTY } from '~/issues/constants';
import StatusIcon from './widget/status_icon.vue';
export default {
    name: 'MrWidgetStatusIcon',
    components: {
        StatusIcon,
        GlIcon
    },
    props: {
        status: {
            type: String,
            required: true
        }
    },
    computed: {
        isClosed () {
            return this.status === STATUS_CLOSED;
        },
        isLoading () {
            return this.status === 'loading';
        },
        isMerged () {
            return this.status === STATUS_MERGED;
        },
        isEmpty () {
            return this.status === STATUS_EMPTY;
        }
    }
};
